import { ThemedText } from '@/components/themed-text';
import { PressableScale } from '@/components/ui/pressable-scale';
import { cn } from '@/utils/cn';
import { Ionicons } from '@expo/vector-icons';
import { Link } from 'expo-router';
import React from 'react';
import { View } from 'react-native';

/**
 * Rota pública da central "Receber pela Controlapag" (plano, seção 6.8;
 * T8.1). Sem login — dá para linkar de `suporte.tsx`, das telas de
 * pagamento (seção 6.1, botão "Ver como funciona") e de fora do app.
 */
export const PAYMENT_HELP_CENTER_PATH = '/ajuda/recebimentos';

interface PaymentHelpCenterLinkProps {
  title?: string;
  subtitle?: string;
  className?: string;
}

/**
 * Linha clicável para a central de ajuda do recebimento automático — mesmo
 * formato da linha "E-mail" em `suporte.tsx`, para as telas de pagamento
 * (T4.2+) reaproveitarem em vez de montar o card de novo.
 */
export function PaymentHelpCenterLink({
  title = 'Receber pela Controlapag',
  subtitle = 'Como funciona, taxas e perguntas frequentes',
  className,
}: PaymentHelpCenterLinkProps) {
  return (
    <Link href={PAYMENT_HELP_CENTER_PATH} asChild>
      <PressableScale
        haptic
        className={cn(
          'flex-row items-center gap-3 rounded-xl border border-border bg-background p-4',
          className,
        )}
      >
        <View className="rounded-full bg-primary/10 p-2">
          <Ionicons name="help-buoy-outline" size={22} color="#FD5001" />
        </View>
        <View className="flex-1">
          <ThemedText className="font-medium text-base text-primary">{title}</ThemedText>
          <ThemedText className="text-sm opacity-60">{subtitle}</ThemedText>
        </View>
        <Ionicons name="chevron-forward" size={18} color="#FD5001" />
      </PressableScale>
    </Link>
  );
}
